import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = "Sapienta VC - Intelligent Capital for Technology & Innovation",
  description = "Sapienta VC is a holding company and family office that provides intelligent capital across payments, technology, artificial intelligence, cybersecurity, and crypto.",
  keywords = "venture capital, family office, holding company, payments, artificial intelligence, cybersecurity, crypto, technology investment, intelligent capital",
  image = "https://sapienta.vc/img/sainet_logo.svg",
  url = "https://sapienta.vc/",
  type = "website",
  author = "Sapienta VC",
  structuredData,
  canonical,
  noindex = false
}) => {
  const siteTitle = "Sapienta VC";
  const fullTitle = title.includes(siteTitle) ? title : `${title} | ${siteTitle}`;
  const currentUrl = canonical || url;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      {noindex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow" />
      )}
      
      {/* Canonical URL */}
      <link rel="canonical" href={currentUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={siteTitle} />
      <meta property="og:locale" content="en_US" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={currentUrl} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
      
      {/* Additional structured data if provided */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO; 